export default {
      id: "login-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#login",
      toString: function () {
        return this.url;
      }
    }